var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuscaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.5833 98.3333L54.375 78.3333L63.125 69.5833L74.375 80.8333L95.2083 60L103.958 68.75L74.5833 98.3333ZM163.333 175L110.833 122.5C106.667 125.833 101.875 128.472 96.4583 130.417C91.0417 132.361 85.2778 133.333 79.1667 133.333C64.0278 133.333 51.2153 128.09 40.7292 117.604C30.2431 107.118 25 94.3055 25 79.1667C25 64.0278 30.2431 51.2153 40.7292 40.7292C51.2153 30.2431 64.0278 25 79.1667 25C94.3055 25 107.118 30.2431 117.604 40.7292C128.09 51.2153 133.333 64.0278 133.333 79.1667C133.333 85.2778 132.361 91.0417 130.417 96.4583C128.472 101.875 125.833 106.667 122.5 110.833L175 163.333L163.333 175ZM79.1667 116.667C89.5833 116.667 98.4375 113.021 105.729 105.729C113.021 98.4375 116.667 89.5833 116.667 79.1667C116.667 68.75 113.021 59.8958 105.729 52.6042C98.4375 45.3125 89.5833 41.6667 79.1667 41.6667C68.75 41.6667 59.8958 45.3125 52.6042 52.6042C45.3125 59.8958 41.6667 68.75 41.6667 79.1667C41.6667 89.5833 45.3125 98.4375 52.6042 105.729C59.8958 113.021 68.75 116.667 79.1667 116.667Z",
    fill: "#E8EAED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuscaIcon);
export default __webpack_public_path__ + "static/media/buscaIcon.59f9e0cfb5f75abf698c7a6f9750ab1b.svg";
export { ForwardRef as ReactComponent };